export enum HanziType {
	SIMPLIFIED = 'SIMPLIFIED',
	TRADITIONAL = 'TRADITIONAL'
}